
import Vue from 'vue';
import Vuex from 'vuex';
import authentication from './authentication';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    state: {
        minutos: 15,
        segundos: 0,
        mostrarAlertaTimeOut: false
    },
    modules: {
        authentication,
    },
    mutations: {
        setMinutos (state, minutos) {
            state.minutos = minutos;
        },
        setSegundos (state, segundos) {
            state.segundos = segundos
        },
        setTiempo (state, tiempo) {
            state.tiempo = tiempo;
        },
        setMostrarAlertaTimeOut (state, mostrarAlertaTimeOut){
            state.mostrarAlertaTimeOut = mostrarAlertaTimeOut;
        }
    },
    actions: {
        continueSession() {
            console.log('continuar sesion');
        }
    },
    plugins: [
        createPersistedState(),
    ],
});
